var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 127,
    viewBox: "0 0 91 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.134 3.09994 0 6.92391 0H63L91 29V120C91 123.866 87.9001 127 84.0761 127H6.92391C3.09994 127 0 123.866 0 120V7Z",
    fill: "#6BC2D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53L64 25H87L91 29V53Z",
    fill: "#0999B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 0.000244141L91 29.0002H69.7586C66.0259 29.0002 63 25.8662 63 22.0002V0.000244141Z",
    fill: "#FEF8F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7417 52.29H66.6449",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7742 97H58.0645",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4192 41L45.1934 95.6452",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9794 78.5C32.0078 83.8789 27.9669 87.5 23.7 87.5C19.433 87.5 15.3921 83.8789 14.4205 78.5H32.9794Z",
    stroke: "#FEF8F7",
    strokeWidth: 5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2795 78.5C75.3078 83.8789 71.267 87.5 67 87.5C62.733 87.5 58.6922 83.8789 57.7205 78.5H76.2795Z",
    stroke: "#FEF8F7",
    strokeWidth: 5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.226 76.2256L23.5109 52.7417L14.2583 76.2256",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5805 76.2256L66.8653 52.7417L57.6128 76.2256",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/Legal.6c232d7d2e0eda27c35081ff140fc907.svg";
export { ForwardRef as ReactComponent };